import PropTypes from 'prop-types'
import {
  NotFoundHeader,
  NotFoundContainer,
  NotFoundDescription,
  NotFoundIcon
} from './styled-components'

const NotFoundComponent = ({ icon, header, description, ...props }) => (
  <NotFoundContainer {...props}>
    <NotFoundIcon>{icon}</NotFoundIcon>
    <NotFoundHeader>{header}</NotFoundHeader>
    <NotFoundDescription>{description}</NotFoundDescription>
  </NotFoundContainer>
)

NotFoundComponent.propTypes = {
  icon: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default NotFoundComponent
